import { ToWords } from "to-words/en-IN";
import type { ReceiptLineItem } from "@/components/common-receipt/CommonReceiptA5";
import {
  defaultA5ChromeProps,
  onlineOrPlainPaymentText,
} from "@/components/common-receipt/a5-print-defaults";

const toWords = new ToWords();

export type LagatReceiptPrintRecord = {
  id?: string | number;
  receiptNo?: string | number;
  receiptDate?: string | Date;
  name?: string;
  itsNo?: string | number;
  amount?: number;
  paymentMode?: string;
  paymentRef?: string | null;
  purposeName?: string;
  purpose?: string;
  createdBy?: string;
  updatedBy?: string;
};

export function lagatReceiptPaymentText(data: LagatReceiptPrintRecord): string {
  return onlineOrPlainPaymentText(data.paymentMode, data.paymentRef);
}

export function lagatReceiptLines(data: LagatReceiptPrintRecord): ReceiptLineItem[] {
  const paymentText = lagatReceiptPaymentText(data);
  return [
    {
      left: "Received from",
      right: `${String(data.name ?? "")} ${data.itsNo ? `(ITS - ${String(data.itsNo)})` : ""}`,
      bold: true,
    },
    {
      left: "The sum of Rupees",
      right: `${toWords.convert(Number(data.amount) || 0)} Only`,
      bold: true,
    },
    {
      left: "Received by",
      right: paymentText.toLowerCase(),
      capitalize: true,
    },
    {
      left: "Towards",
      right: String(data.purposeName ?? data.purpose ?? "Voluntary Contribution"),
    },
  ];
}

export function lagatReceiptA5Props(data: LagatReceiptPrintRecord) {
  return {
    ...defaultA5ChromeProps(),
    receiptNo: data.receiptNo != null ? String(data.receiptNo) : undefined,
    date: data.receiptDate,
    receiptLines: lagatReceiptLines(data),
    amount: Number(data.amount),
    digitalSignatureValue: `${String(data.id)}|${String(data.updatedBy ?? data.createdBy ?? "")}`,
    receiptHeaderText: "LAGAT RECEIPT",
  };
}
